// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"28":"6dcc2da2","37":"caaaf80e","97":"50887c62","138":"06aa478c","189":"24d3b45f","310":"2c875521","446":"49a33893","497":"b7de24fe","731":"0a1ccaf1","817":"1fefffe9","862":"435e9339","970":"16c5e88c"}[chunkId] + ".chunk.js";
};